export default __webpack_public_path__ + "static/media/tv-paga.8a40d950.pdf";